import moment from 'moment'
import ReservaAPI from '@/api/reserva'
import ConvidadosAPI from '@/api/convidados'

export default {
  clear({ commit }) {
    commit('SET_RESERVAS', [])
  },

  clearMine({ commit }) {
    commit('SET_MINHAS_RESERVAS', [])
  },

  clearAreasDisponiveis({ commit }) {
    commit('SET_AREAS_DISPONIVEIS', [])
  },

  clearAll({ commit }) {
    commit('SET_RESERVAS', [])
    commit('SET_MINHAS_RESERVAS', [])
    commit('SET_AREAS_DISPONIVEIS', [])
    commit('SET_RESERVA_EM_ANDAMENTO', {})
    commit('SET_TERMO_RESERVA_EM_ANDAMENTO', '')
  },

  reservaEmAndamento({ commit }, reservaEmAndamento) {
    commit('SET_RESERVA_EM_ANDAMENTO', reservaEmAndamento)

    reservaEmAndamento.descricao = 'Reservado Pelo App'

    return new Promise((resolve, reject) => {
      if (reservaEmAndamento.restricao && reservaEmAndamento.unidade) {
        ReservaAPI.postPreparaTermo(reservaEmAndamento)
          .then(response => {
            commit('SET_TERMO_RESERVA_EM_ANDAMENTO', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      } else {
        commit('SET_TERMO_RESERVA_EM_ANDAMENTO', '')
        resolve({})
      }
    })
  },
  fetchAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      ReservaAPI.listEventos(params.page)
        .then(response => {
          commit('ADD_RESERVAS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchAllMine({ commit }, params) {
    return new Promise((resolve, reject) => {
      ReservaAPI.listMeusEventos(params.page)
        .then(response => {
          commit('ADD_MINHAS_RESERVAS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchAreasDisponiveis({ commit }, params) {
    commit('SET_AREAS_DISPONIVEIS', {})

    return new Promise((resolve, reject) => {
      ReservaAPI.listAreasDisponiveis(moment(params.data).format('YYYY-MM-DD'), params.unidade)
        .then(response => {
          commit('SET_AREAS_DISPONIVEIS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  confirmarReserva({ commit }, params) {
    return new Promise((resolve, reject) => {
      ReservaAPI.postEvento(params.reservaEmAndamento)
        .then(response => {
          commit('SET_TERMO_RESERVA_EM_ANDAMENTO', '')
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  cancelarReserva({ commit }, params) {
    return new Promise((resolve, reject) => {
      ReservaAPI.deleteEvento(params.evento.id)
        .then(() => {
          commit('DELETE_MINHAS_RESERVAS', params.evento)
          resolve({})
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-unused-vars
  solicitarSuplencia({ commit }, params) {
    return new Promise((resolve, reject) => {
      ReservaAPI.solicitarSuplencia(params.eventoId, params.unidadeId)
        .then(() => {
          resolve({})
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-unused-vars
  fetchSuplencias({ commit }, params) {
    return new Promise((resolve, reject) => {
      ReservaAPI.listSuplencias(params.eventoId)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchConvidados({ commit }, params) {
    return new Promise((resolve, reject) => {
      ConvidadosAPI.listByEvento(params.eventoId)
        .then(response => {
          commit('SET_CONVIDADOS', response.data)
          resolve(response)
        })
        .catch(error => {
          commit('SET_CONVIDADOS', [])
          reject(error)
        })
    })
  },
  addConvidado({ commit }, params) {
    return new Promise((resolve, reject) => {
      ConvidadosAPI.create(params.eventoId, params.convidado)
        .then(response => {
          commit('ADD_CONVIDADO', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  removeConvidado({ commit }, params) {
    return new Promise((resolve, reject) => {
      ConvidadosAPI.remove(params.id)
        .then(() => {
          commit('REMOVE_CONVIDADO', params.id)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  togglePresenca({ commit }, params) {
    return new Promise((resolve, reject) => {
      ConvidadosAPI.togglePresenca(params.id)
        .then(response => {
          commit('UPDATE_CONVIDADO', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
